<template lang="html">
    <sui-modal id="modalImprint" v-model="open"  :closable="false">
      <sui-modal-header>Impressum</sui-modal-header>
      <sui-modal-content scrolling image>
        <sui-modal-description>
          <fieldset>
            <pre>
            LAN1 Hotspots GmbH
            Gaußstraße 158
            D-22765 Hamburg

            Tel.: 	+49 (0)40 317 66 66 0
            Fax.: 	+49 (0)40 317 66 66 33
            E-mail: info[at]lan1.de
            www: lan1.de
            Handelsregister Hamburg HRB 118700 
            Umsatzsteuer-Identifikationsnummer
            gemäß §27 a Umsatzsteuergesetz: DE277065194
            Geschäftsführung: Jörg Hümmer
            </pre>
          </fieldset>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click="toggle">Close</sui-button>
      </sui-modal-actions>
    </sui-modal>
</template>

<script>
  export default {
    name: 'Imprint',
    props: ['open'],
    methods: {
      toggle(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('closeModal')
      },
    },
  };
</script>
